<template>
    <div class="BCwrapper" v-if="!isMobileApp">
        <CloseDetail
            v-if="displayBack"
            :label="mobileItem.text"
            :to="mobileItem.path"
        ></CloseDetail>
        <div class="breadcrumbs" v-else>
            <template v-for="(item, i) in items">
                <router-link
                    v-if="i + 1 < items.length"
                    class="item grey"
                    :key="item.text"
                    :to="item.path"
                >{{ item.text }}</router-link>

                <div
                    v-else
                    class="item current"
                    :key="item.text"
                >{{ item.text }}</div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CloseDetail from "./CloseDetail";

const getters = [
    'is_collapsed',
    'isMobileApp',
];

export default {
    computed: {
        ...mapGetters(getters),
        mobileItem() {
            return (this.items.length > 1) 
                ? this.items[this.items.length - 2]
                : this.items[this.items.length - 1];
        },
        displayBack() {
            return this.is_collapsed && this.items.length > 2;
        },
    },
    props: {
        items: {
            type: Array,
            default: () => ([
                { text: 'Главная', path: { name: 'portal-main' }},
            ]),
        },
    },
    components: { CloseDetail },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/rem';
    @import '../../styles/mrem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    .BCwrapper {
        margin: 0 !important;
    }
    .breadcrumbs {
        @include on-mobile {
            margin: mrem(24) mrem(16);
            font-size: 12px;
            line-height: 15px;
        }
    }

</style>
